import { useEffect } from 'react';
import ReactDOM from 'react-dom';

type Props = {
  children: any;
  blockZindex?: boolean;
  id?: string;
};

function PortalModalWrapper({ children, blockZindex, id }: Props): any {
  const el = document.getElementById('portalModal');

  useEffect(() => {
    const updateZIndex = () => {
      const portalEl = document.getElementById('portalModal');
      if (!portalEl) return;
      const modalCount =
        document.getElementsByClassName('portalModalContent').length;
      portalEl.style.zIndex = modalCount > 0 ? '4' : '0';
    };

    // mount 직후 + 다음 틱에서 모두 보정
    updateZIndex();
    const raf = requestAnimationFrame(updateZIndex);
    const tid = setTimeout(updateZIndex, 0);

    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(tid);
      // unmount 후 DOM 반영 다음 틱에서 재계산
      setTimeout(updateZIndex, 0);
    };
  }, [children]);

  if (!el || !children) return null;

  return ReactDOM.createPortal(children, el);
}

export default PortalModalWrapper;
